import React from 'react';
import css from './PillsTabs.module.scss';
import PropTypes from 'prop-types';

const PillsTabs = ({
  children,
  className,
  style,
  fullWidth = false,
  singleRow = false,
}) => {
  return (
    <div
      className={`${css.pillsTabsWrapper} ${fullWidth ? css.fullWidth : ''} ${singleRow ? css.singleRow : ''} ${className || ''}`}
      style={style}
    >
      <div className={css.pillsTabs}>
        {children}
      </div>
    </div>
  );
};

PillsTabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  // Keeps the tabs on one row on mobile instead of stacking them. Only for a few short options
  // that fit the width; longer sets should keep stacking.
  singleRow: PropTypes.bool,
};

export default PillsTabs;
